import { render, staticRenderFns } from "./TextPrompt.vue?vue&type=template&id=94763b7e"
import script from "./TextPrompt.vue?vue&type=script&lang=js"
export * from "./TextPrompt.vue?vue&type=script&lang=js"
import style0 from "./TextPrompt.vue?vue&type=style&index=0&id=94763b7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports